import { Component, EventEmitter, OnInit, Output, ViewChild, inject, ChangeDetectorRef } from '@angular/core';
import { WestnetzSidenavService } from '../../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { NotificationService } from '../../../service/common/notification/notification.service';
import { DatenabfrageService } from '../../../service/datenabfrage/datenabfrage.service';
import { Datenabfrage } from '../../../domain/model/datenabfrage/datenabfrage';
import { NgForm } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TeilgebietSelectionService } from '../../../service/common/teilgebiet/teilgebiet-selection.service';
import { Aufteilungsschluessel } from '../../../domain/model/datenabfrage/aufteilungsschluessel';
@Component({
    selector: 'tnb-aufteilungsschluessel-eintragen-detail',
    templateUrl: './aufteilungsschluessel-eintragen.component.html',
    styleUrls: [
        './aufteilungsschluessel-eintragen.component.scss',
    ],
    standalone: false,
})
export class AufteilungsschluesselEintragenComponent implements OnInit {
    westnetzSidenavService = inject(WestnetzSidenavService);
    private notificationService = inject(NotificationService);
    private datenabfrageService = inject(DatenabfrageService);
    private teilgebietSelectionService = inject(TeilgebietSelectionService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild('aufteilungsschluesselEintragenForm', { static: true }) public aufteilungsschluesselEintragenForm: NgForm;

    public aufteilungsschluessel: Aufteilungsschluessel = new Aufteilungsschluessel();
    public datenabfrage: Datenabfrage;
    @Output() atsChanged = new EventEmitter<void>();

    ngOnInit() {
        this.datenabfrageService.getAktiveDatenAbfrage(false, this.teilgebietSelectionService.getSelectedStadtwerkeId())
            .pipe(take(1))
            .subscribe((abfrage: Datenabfrage) => {
                this.datenabfrage = abfrage;
                this.changeDetectorRef.markForCheck();
                this.datenabfrageService.getAufteilungsschluessel(
                    abfrage.id,
                    this.teilgebietSelectionService.getSelectedStadtwerkeId(),
                )
                    .pipe(take(1))
                    .subscribe((as: Aufteilungsschluessel[]) => {
                        if (as.length > 0) {
                            this.aufteilungsschluessel = as[0];
                            this.changeDetectorRef.markForCheck();
                        }
                    });
            });
    }

    public saveAufteilungsschluessel() {
        this.datenabfrageService.saveAufteilungsschluessel(
            this.datenabfrage.id,
            this.teilgebietSelectionService.getSelectedStadtwerkeId(),
            this.aufteilungsschluessel,
        )
            .pipe(take(1))
            .subscribe(() => {
                this.westnetzSidenavService.closeRightnav();
                this.atsChanged.emit();
                this.notificationService.success('Die Daten zum Aufteilungsschluessel wurden gespeichert');
            });
    }
}
